import { createSlice } from '@reduxjs/toolkit'
import { fetchLogisticsData, updateLogisticsData } from './thunks'

export const logisticsSlice = createSlice({
	name: 'logisticsSlice',
	initialState: {
		// TODO: break these down into three separate slices after demo. the use of one loading for three things is not smart
		vehicleLogistics: { collection: null, delivery: null, 'logistic-plan': null },
		loading: false,
		errored: false,
		error: '',
		logisticDataRefresh: true,
	},
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(fetchLogisticsData.pending, state => {
				state.loading = true
			})
			.addCase(fetchLogisticsData.fulfilled, (state, action) => {
				const logisticsType: 'collection' | 'delivery' | 'logistic-plan' = action.meta.arg.category
				state.logisticDataRefresh = false
				state.loading = false
				state.vehicleLogistics[logisticsType] = action.payload
			})
			.addCase(fetchLogisticsData.rejected, (state, action) => {
				state.logisticDataRefresh = false
				state.loading = false
				state.errored = true
				state.error = action.error.toString()
			})
			.addCase(updateLogisticsData.pending, state => {
				state.loading = true
			})
			.addCase(updateLogisticsData.fulfilled, (state, action) => {
				state.loading = false
				state.logisticDataRefresh = true
			})
			.addCase(updateLogisticsData.rejected, (state, action) => {
				state.logisticDataRefresh = true
				state.loading = false
				state.errored = true
				state.error = action.error.toString()
			})
	},
})
export const logisticsSliceReducer = logisticsSlice.reducer
